import { render } from "./DivideInfoCard.vue?vue&type=template&id=18bb3570"
import script from "./DivideInfoCard.vue?vue&type=script&lang=js"
export * from "./DivideInfoCard.vue?vue&type=script&lang=js"

import "./DivideInfoCard.vue?vue&type=style&index=0&id=18bb3570&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__